import React, { CSSProperties, useCallback } from 'react';

import classNames from 'classnames';

import Button from '../Button';
import MarkIcon from '../icons/Mark';
import PlusIcon from '../icons/Plus';
import PlusSmallIcon from '../icons/PlusSmall';

import styles from './styles.module.scss';

type CheckboxType = {
	checked?: boolean;
	onChange?: (checked: boolean, name?: string) => void;
	withShadow?: boolean;
	disabled?: boolean;
	fakeDisabled?: boolean;
	size?: 'x-small' | 'small';
	className?: string;
	style?: CSSProperties;
	loading?: boolean;
	appearance?: 'default' | 'classic' | 'tumbler';
	name?: string;
};

const Checkbox: React.FC<CheckboxType> = ({
	checked,
	onChange,
	withShadow,
	disabled,
	size = 'x-small',
	style,
	className,
	loading,
	fakeDisabled,
	appearance = 'default',
	name,
}) => {
	const handleChange = useCallback(() => {
		onChange?.(!checked, name);
	}, [checked, name, onChange, fakeDisabled, disabled]);

	return appearance === 'tumbler' ? (
		<div
			className={classNames([
				className,
				styles.tumbler,
				size === 'small' && styles.small,
				// styles.small,
				checked && styles.checked,
				disabled && styles.disabled,
			])}
			onClick={disabled ? undefined : handleChange}
			style={style}>
			<div className={styles.tumblerBack} />
			<div className={styles.tumblerFront} />
		</div>
	) : (
		<Button
			style={style}
			onClick={handleChange}
			size={size}
			fakeDisabled={fakeDisabled}
			disabled={disabled}
			withShadow={withShadow}
			loading={loading}
			appearance={checked ? 'primary' : 'stroke'}
			className={classNames([
				className,
				styles.checkbox,
				checked && styles.checked,
				size === 'x-small' && styles.extraSmall,
				size === 'small' && styles.small,
			])}>
			{checked && <MarkIcon />}
			{!checked && appearance !== 'classic' && (
				<>{size === 'x-small' ? <PlusSmallIcon /> : <PlusIcon size={24} />}</>
			)}
		</Button>
	);
};

export default Checkbox;
